import { ReactNode } from 'react'
import { BoxProps } from '@mui/material'
import { FullWidthSectionSt, FullWidthSectionInner } from './full-width-section.styled'

interface IProps {
  children: ReactNode
  /**
   * sx prop for the outer container (FullWidthSectionSt)
   * Use this to customize the full-width wrapper styles
   */
  sx?: BoxProps['sx']
  /**
   * sxInner prop for the inner container (FullWidthSectionInner)
   * Use this to customize the inner container styles, e.g., change max-width
   * Example: sxInner={{ maxWidth: '1000px' }}
   */
  sxInner?: BoxProps['sx']
  /**
   * id prop for the outer container (FullWidthSectionSt)
   * Required to ensure each instance has a unique ID.
   * The script (add-static-ids.mjs) will skip elements that already have an id.
   * 
   * Example: id="index__pages-product__fullwidthsectionst__l118"
   */
  id: string
  /**
   * idInner prop for the inner container (FullWidthSectionInner)
   * Required to ensure each instance has a unique ID.
   * The script (add-static-ids.mjs) will skip elements that already have an id.
   * 
   * Example: idInner="index__pages-product__fullwidthsectioninner__l118"
   */
  idInner: string
}

export const FullWidthSection = ({ children, sx, sxInner, id, idInner }: IProps) => {
  return (
    <FullWidthSectionSt id={id} sx={sx}>
      <FullWidthSectionInner id={idInner} sx={sxInner}>
        {children}
      </FullWidthSectionInner>
    </FullWidthSectionSt>
  )
}
